import type { ApiModuleEndpoints } from '../types'

export const deliveryPartnerApiEndpoints = {
  list: {
    method: 'GET',
    path: '/delivery-partners',
    requiresAuth: true,
  },
  options: {
    method: 'GET',
    path: '/delivery-partners/options',
    requiresAuth: true,
  },
  detail: {
    method: 'GET',
    path: '/delivery-partners/:id',
    requiresAuth: true,
  },
  create: {
    method: 'POST',
    path: '/delivery-partners',
    requiresAuth: true,
  },
  update: {
    method: 'PUT',
    path: '/delivery-partners/:id',
    requiresAuth: true,
  },
  delete: {
    method: 'DELETE',
    path: '/delivery-partners/:id',
    requiresAuth: true,
  },
} as const satisfies ApiModuleEndpoints
